import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { useInstance } from 'intact-vue';
import { isNullOrUndefined } from 'intact-shared';
var prefix = '__$_';
export function useNodes() {
  var instance = useInstance();
  var nodes = [];
  instance.watch('data', function (data) {
    nodes = createNodes(data, null, prefix);
  });
  return {
    getNodes: function getNodes() {
      return nodes;
    }
  };
}
export var Node = function Node(data, parent, key) {
  this.data = void 0;
  this.parent = void 0;
  this.key = void 0;
  this.checked = false;
  this.indeterminate = false;
  this.children = null;
  this.loaded = void 0;
  this.filter = true;
  this.data = data;
  this.parent = parent;
  this.key = key;
  this.loaded = isNullOrUndefined(data.loaded) && data.children && data.children.length ? true : data.loaded;
};
function createNode(data, parent, prefix, reference) {
  var key = isNullOrUndefined(data.key) ? "" + prefix + reference.index++ : data.key;
  var node = new Node(data, parent, key);
  if (data.children) {
    var subPrefix = isNullOrUndefined(data.key) ? key + "." : "" + prefix + reference.index + ".";
    node.children = createNodes(data.children, node, subPrefix);
  }
  return node;
}
function createNodes(data, parent, prefix) {
  if (isNullOrUndefined(data)) return [];
  var reference = {
    index: 0
  };
  return _mapInstanceProperty(data).call(data, function (data) {
    return createNode(data, parent, prefix, reference);
  });
}